import React, { FunctionComponent, useRef } from 'react';
import { SearchBox } from '@fluentui/react';
import { EventEx } from '../../Utilities/EventEx';
import { Timeout } from '../../types/runtimeTypes';
import { useTranslation } from '../../Locales/i18n/localizationService';
 
interface IProps {
	ClassName?: string;
	OnChange: (value: string) => void;
	Delay?: number;
	Disabled?: boolean;
	SearchPlaceHolder?: string;
	onFocus?: (event: any) => void;
}

export const DelayedSearchBox: FunctionComponent<IProps> = props => {
	const { t } = useTranslation();
	const _searchTimer = useRef<Timeout>();

	const OnChange = (value: string) : void => {
		const newTimer = EventEx.delay(_searchTimer.current, () => props.OnChange(value), props.Delay);
		_searchTimer.current = newTimer;
    }
	
	return 	<SearchBox 
				className={props.ClassName}
				placeholder={props.SearchPlaceHolder || `${t("Common.Search")}..`} 
				onChange={(e, newValue) => OnChange(newValue ?? "")}
				disabled={props.Disabled}
				styles={{ root: { maxWidth: "450px" }}}
				autoFocus
				autoComplete={'off'}
				onFocus={props.onFocus}
			/>
}
